import React from "react"

import { Icon } from "@/components/Icon"
import { Tooltip } from "@mantine/core"

import { useStyles } from "@/components/IconWithTooltip/IconWithTooltip.styles"

const ICON_SIZES = ["lg", "xs", "sm", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]

export interface IconWithTooltipProps {
    icon?: string
    iconColor?: string
    iconFamily?: string
    iconSize?: number | "lg" | "xs" | "sm" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x"
    iconStyle?: any
    label?: string
    onClick?: (evt: any) => unknown
    tooltipPosition?: string
    withArrow?: boolean
}

export const IconWithTooltip = ({
    icon,
    iconColor,
    iconFamily = "far",
    iconSize,
    iconStyle,
    label,
    onClick,
    tooltipPosition,
    withArrow = true,
}: IconWithTooltipProps) => {
    const { classes } = useStyles()

    // default icon size to 1x if not provided or invalid
    if (!iconSize || !ICON_SIZES.includes(iconSize as string)) {
        iconSize = "1x"
    }

    return (
        <Tooltip
            arrowSize={5}
            className={classes.tooltip}
            label={label}
            position={(tooltipPosition as any) || "top"}
            withArrow={withArrow}
        >
            <Icon
                className={classes.icon}
                color={iconColor}
                icon={icon}
                iconFamily={iconFamily}
                onClick={onClick}
                size={iconSize}
                style={iconStyle}
            />
        </Tooltip>
    )
}
